import { ApiResponse, IProjectDocument } from "../../../core/_models";
import { requestLaravel } from "../../../../../utils/api";

// A section (tbl_project_sections.section_key) limits the list to that section's documents.
export function getProjectDocuments(payload: { project_id: number, stage_id?: string, section?: string },signal?: AbortSignal) {
    return requestLaravel<ApiResponse<IProjectDocument[]>>("project-documents/get-project-documents", payload, { signal });
}

// With a section, the documents are stored against it and the response lists only that section's documents.
export function updateProjectDocuments(payload: { project_id: number, stage_id: string, doc_source?: 'stage' | 'other', section?: string, documents: IProjectDocument[] },signal?: AbortSignal) {
    const documents: IProjectDocument[] = payload.documents;
    return requestLaravel<ApiResponse<{documents: IProjectDocument[]}>>("project-documents/upload-project-documents", {
        ...payload, documents: documents.filter((document: IProjectDocument) => document?.doc_id === 0)
    });
}

// Documents of one stage section, uploaded straight away rather than with the step's Save.
export function getSectionDocuments(project_id: number | string, stage_id: string, section: string, signal?: AbortSignal) {
    return getProjectDocuments({ project_id: Number(project_id), stage_id, section }, signal);
}

export function uploadSectionDocument(project_id: number | string, stage_id: string, section: string, document: IProjectDocument) {
    return updateProjectDocuments({ project_id: Number(project_id), stage_id, section, documents: [document] });
}

export function deleteProjectDocuments(payload: { project_id: number, doc_id: number },signal?: AbortSignal) {
    return requestLaravel<ApiResponse<IProjectDocument>>("project-documents/delete-project-document", payload, { signal });
}